import React from 'react';
import { Button } from './ui/Button';
import { Calendar, Users, Trophy } from 'lucide-react';
const tournaments = [{
  name: 'Apex Velocity Cup',
  prize: '€15,000',
  date: 'MAR 12-14',
  players: '128/256',
  status: 'Registering'
}, {
  name: 'Crimson Rush Championship',
  prize: '€25,000',
  date: 'APR 05-08',
  players: '64/512',
  status: 'Upcoming'
}, {
  name: 'Vertigo Series',
  prize: '€10,000',
  date: 'FEB 28',
  players: 'FULL',
  status: 'Live Now'
}];
export function Tournaments() {
  return <section className="bg-neutral-900 py-24 border-y border-neutral-800" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-160">
          <div data-id="element-161">
            <h2 className="text-4xl md:text-6xl font-black text-white uppercase italic tracking-tighter" data-id="element-162">
              Active <span className="text-red-600" data-id="element-163">Events</span>
            </h2>
          </div>
          <Button variant="outline" className="mt-6 md:mt-0" data-id="element-164">
            View All Brackets
          </Button>
        </div>

        <div className="space-y-4" data-id="element-165">
          {tournaments.map((event, index) => <div key={index} className="group relative bg-neutral-950 border border-neutral-800 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 hover:border-red-600 transition-colors duration-300 overflow-hidden" data-id="element-166">
              {/* Hover Effect Background */}
              <div className="absolute inset-0 bg-red-600/5 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500 skew-x-[-20deg]" data-id="element-167" />

              <div className="relative z-10 flex-1 w-full" data-id="element-168">
                <div className="flex items-center gap-3 mb-2" data-id="element-169">
                  <span className={`px-2 py-0.5 text-xs font-bold uppercase tracking-wider rounded ${event.status === 'Live Now' ? 'bg-red-600 text-white animate-pulse' : event.status === 'Registering' ? 'bg-green-600 text-white' : 'bg-neutral-800 text-neutral-400'}`} data-id="element-170">
                    {event.status}
                  </span>
                  <span className="text-neutral-500 text-sm font-mono flex items-center gap-1" data-id="element-171">
                    <Calendar className="w-3 h-3" data-id="element-172" /> {event.date}
                  </span>
                </div>
                <h3 className="text-2xl md:text-3xl font-black text-white uppercase italic" data-id="element-173">
                  {event.name}
                </h3>
              </div>

              <div className="relative z-10 flex items-center gap-8 w-full md:w-auto justify-between md:justify-end" data-id="element-174">
                <div className="text-right" data-id="element-175">
                  <div className="text-neutral-500 text-xs uppercase tracking-wider mb-1 flex items-center justify-end gap-1" data-id="element-176">
                    <Users className="w-3 h-3" data-id="element-177" /> Players
                  </div>
                  <div className="text-white font-mono font-bold" data-id="element-178">
                    {event.players}
                  </div>
                </div>

                <div className="text-right" data-id="element-179">
                  <div className="text-neutral-500 text-xs uppercase tracking-wider mb-1 flex items-center justify-end gap-1" data-id="element-180">
                    <Trophy className="w-3 h-3" data-id="element-181" /> Prize Pool
                  </div>
                  <div className="text-red-500 font-black text-2xl" data-id="element-182">
                    {event.prize}
                  </div>
                </div>

                <Button size="sm" className="hidden md:inline-flex opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-183">
                  Enter
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}